import { atom } from "recoil";

export const polarRotationState = atom({
  key: 'polarRotationState',
  default: 140
});
